import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const RangeBox = styled.div`
  width: 100%;
  padding: 35px 20px 0 10px;

  &.read-only {
    pointer-events: none;
  }

  &.is-range {
    & .range-slider_text {
      display: none;
    }
  }

  & .range-slider {
    height: 8px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.07);
  }

  & .range-slider.single-thumb {
    & .range-slider__thumb[data-lower] {
      width: 0;
      &::before {
        content: "";
        display: none;
      }
    }
    & .range-slider__range {
      border-radius: 6px;
    }
  }

  & .range-slider .range-slider__range {
    background-color: var(--bg-button);
  }

  & .range-slider .range-slider__thumb {
    /* position: relative; */
    width: 20px;
    height: 20px;
    background-color: var(--bg-button);

    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 4px;
      left: 4px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: var(--bg-color);
    }

    &::after {
      content: '';
      position: absolute;
      top: -4px;
      left: -4px;
      width: 28px;
      height: 28px;
      opacity: 0;
    }

    /* &::after {
      content: "";
      display: block;
      position: absolute;
      top: 12px;
      left: 12px;
      margin: -22px;
      padding: 22px;
    } */

    &[data-active] {
      .range-slider_text {
        display: block;
      }
    }

    & .range-slider_text {
      position: absolute;
      top: -27px;
      left: 50%;
      transform: translateX(-50%);
      padding: 2px 10px;
      font-weight: 400;
      font-size: 14px;  //11
      line-height: 1.45;
      border-radius: 3px;
      color: var(--text-color);
      background-color: rgba(255, 255, 255, 0.07);

      &::before {
        content: "";
        position: absolute;
        bottom: -11px;
        left: 50%;
        transform: translateX(-50%);
        display: block;
        border: 7px solid transparent;
        border-top: 4px solid rgba(255, 255, 255, 0.07);
      }
    }
  }
`;

export const RangeText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 13px;
  font-weight: 400;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--text-color);

  @media ${device.desktop} {
    font-size: 10px;
    line-height: 1.6;
  }
`;

export const RangeInputs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 34px;

  & .decor-line {
    font-size: 30px;
  }

  & .range-inpup {
    max-width: 150px;
  }

`

export const RangeInputWrapper = styled.div`
  width: 100%;
  max-width: 150px;
`